/* eslint camelcase: 0 */
import common from './common/ja_JP';
import confirmation from './confirmation/ja_JP';
import dapps from './dapps/ja_JP';
import header from './header/ja_JP';
import home from './home/ja_JP';
import footer from './footer/ja_JP';
import gettingStarted from './getting-started/ja_JP';
import privacyPolicy from './privacy-policy/ja_JP';
import termsAndConditions from './terms-of-conditions/ja_JP';
import createWallet from './create-wallet/ja_JP';
import accessWallet from './access-wallet/ja_JP';
import interfaceTranslations from './interface/ja_JP';
import team from './team/ja_JP';
import popover from './popover/ja_JP';
import withoutWallet from './without-wallet/ja_JP';
import errorsGlobal from './errors-global/ja_JP';
import trezorError from './errors-trezor/ja_JP';
import ledgerError from './errors-ledger/ja_JP';
import secalotError from './errors-secalot/ja_JP';
import keepkeyError from './errors-keepkey/ja_JP';
import bitboxError from './errors-bitbox/ja_JP';

const ja_JP = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default ja_JP;
